export const getSignButtonStatus = (signCriteria, response, signWithOutMinimumDataset) => {

  if (signWithOutMinimumDataset === 0) {
    return {
      isSign: true,
      pendingItems: [],
    };
  }
  const pendingItems = [];

  if (!response) {
    return {
      isSign: false,
      pendingItems: [],
    };
  }

  const getPendingItems = (items, requiredKeys, sectionName) => {
    if (!Array.isArray(items)) {
      return requiredKeys.map((requiredKey) => ({
        section: sectionName,
        key: requiredKey.trim(),
        label: requiredKey.trim(),
      }));
    }

    const pendingItems = [];

    requiredKeys.forEach((requiredKey) => {
      const key = requiredKey.trim();

      // Custom forms
      if (key === "customform") {
        const incompleteCustomForms = items.filter((item) => item.isCustomForm && item.isCompleted !== 1);

        incompleteCustomForms.forEach((item) => {
          pendingItems.push({
            section: sectionName,
            key: item.key,
            label: item.value,
          });
        });

        return;
      }

      // Normal fields
      const isCompleted = items.some((item) => item.key?.trim() === key && item.isCompleted === 1);

      if (!isCompleted) {
        const item = items.find((item) => item.key?.trim() === key);

        pendingItems.push({
          section: sectionName,
          key,
          label: item?.value || key,
        });
      }
    });

    return pendingItems;
  };

  // Characteristics
  pendingItems.push(...getPendingItems(response?.characteristics, signCriteria?.characteristics || [], "Characteristics"));

  // Measurements
  pendingItems.push(...getPendingItems(response?.measurements, signCriteria?.measurements || [], "Measurement"));

  // Treatment / Interventions
  const requiredTreatments = signCriteria?.treatment || [];
  const interventions = response?.treatment || [];

  if (Array.isArray(interventions)) {
    interventions.forEach((intervention, index) => {
      pendingItems.push(...getPendingItems(intervention?.items, requiredTreatments, intervention?.name));
    });
  }

  return {
    isSign: pendingItems.length === 0,
    pendingItems,
  };
};
